import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class BodyScrollService {
  enableScroll(): void {
    document.body.style.overflow = 'auto';
  }

  disableScroll(): void {
    document.body.style.overflow = 'hidden';
  }
}
